import { useEffect, useState } from "react"
import { PartyPopper, X } from "lucide-react"

type ClaimedDetail = { claimed: number; correct: number }

export function GuestQuizClaimBanner() {
  const [claimed, setClaimed] = useState<ClaimedDetail | null>(null)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    function onClaimed(event: Event) {
      setClaimed((event as CustomEvent<ClaimedDetail>).detail)
    }
    window.addEventListener("guest-quiz:claimed", onClaimed)
    return () => window.removeEventListener("guest-quiz:claimed", onClaimed)
  }, [])

  if (!claimed || claimed.claimed === 0 || dismissed) return null

  return (
    <div className="bg-green-50 dark:bg-green-950/40 border-b border-green-200 dark:border-green-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3">
        <PartyPopper className="w-4 h-4 text-green-600 dark:text-green-400 shrink-0" />
        <p className="text-sm text-green-800 dark:text-green-300 flex-1">
          Nice — we saved your quiz score! You got {claimed.correct} of {claimed.claimed} correct.
        </p>
        <button
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          className="text-green-500 hover:text-green-700 dark:hover:text-green-300 shrink-0"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}
